import styles from "./OnboardingVolunteer.module.scss";
import { useTranslation } from "../../i18n";
import classNames from "classnames";
import { useEnumStore } from "../../store/enumStore";
import { EventInterestsSkillsSection } from "../EventInterestsSkillsSection/EventInterestsSkillsSection";
import {
  InputMunicipality,
  MunicipalitySuggestion,
} from "../InputMunicipality/InputMunicipality";

interface OnboardingVolunteerSecondStepProps {
  title: string;
  desc: string;
  formData: {
    skills: string[];
    interests: string[];
    locations: MunicipalitySuggestion[];
  };
  onCheckboxToggle: (id: string, field: "skills" | "interests") => void;
  selectedTowns: MunicipalitySuggestion[];
  onSetSelectedTowns: (towns: MunicipalitySuggestion[]) => void;
}

export const OnboardingVolunteerSecondStep = ({
  title,
  desc,
  formData,
  onCheckboxToggle,
  selectedTowns,
  onSetSelectedTowns,
}: OnboardingVolunteerSecondStepProps) => {
  const { t } = useTranslation();
  const skills = useEnumStore((state) => state.skills);

  return (
    <div className={classNames(styles.content)}>
      <h2>{t("onboarding.locationTitle")}</h2>
      <p>{t("onboarding.locationsHint")}</p>
      <InputMunicipality
        selectedTowns={selectedTowns}
        onTownsChange={onSetSelectedTowns}
        label={t("municipality.label")}
      />
      <h2>{title}</h2>
      <p>{desc}</p>
      <EventInterestsSkillsSection
        title=""
        items={skills as any}
        selectedIds={formData.skills}
        onToggle={(id) => onCheckboxToggle(id, "skills")}
        editMode={true}
        userType="volunteer"
        showSubItems={true}
        type="skills"
      />
    </div>
  );
};
